<div class="page">
  @if (!devToolsService.destroyed()) {
    @if (isEmbedded) {
      <div id="chatAndSidebar" class="content">
        @if (aiConfigIncomplete) {
          <p-message severity="warn" [closable]="false" styleClass="ai-config-warning">
            MAIS options are not fully set. Set an Auth Token and Workspace Slug on the
            <a routerLink="/options">Options</a> page to use AI mode.
          </p-message>
        }
        <mi-chat
          #michat
          [theme]="themeService.theme()"
          [locale]="localeService.locale()"
          [conversationId]="conversationId"
          [reloadUser]="false"
          [hostOffline]="devToolsService.hostOffline()"
          [config]="config"
          [previewMode]="devToolsService.previewMode()"
          [aiMode]="aiMode"
          [aiConfig]="aiConfig"
          (onAiThreadReady)="onAiThreadReady($event)"
          (onAiSourcesReceived)="onAiSourcesReceived($event)"
          (onAiStreamError)="onAiStreamError($event)"
          (onAiHandoffRequested)="onAiHandoffRequested($event)"
          id="conversationComponent"
          (onHeaderButtonClick)="headerButtonClick($event)"
          (onUploadStart)="uploadStart($event)"
          (onUploadEnd)="uploadEnd($event)"
          (onActionCardOpenLink)="onActionCardOpenLink($event)"
          (onConversationLoadStart)="conversationLoadStart($event)"
          (onConversationLoadEnd)="conversationLoadEnd($event)"
          [sendOverride]="sendOverride"
          (onNameClick)="nameClicked($event)"
          (onMentionClick)="mentionClicked($event)"
          (onShareLocation)="shareLocation($event)"
          (onActionCardEvent)="onActionCardEvent($event)"
          (onAnalyticEvent)="analyticEvent($event)"
          (onInfoLog)="onChatLog($event)"
          (onErrorLog)="onChatLog($event)"
          (onSelectMessageMode)="onSelectMessageMode($event)"
          (onIgniteHotkeyPressed)="onIgniteHotkeyPressed($event)"
        ></mi-chat>
      </div>
    } @else {
      <div id="chatAndSidebar" class="content">
        <mi-two-pane-layout name="Messages" path="messages">
          <ng-container headerRight>
            <mi-round-button
              #addConversationBtn
              size="md"
              color="primary"
              icon="mi2-add"
              tooltipPosition="left"
              tooltip="New conversation"
              ariaLabel="New conversation"
              data-e2e="add-conversation-trigger"
              (clicked)="openAddConversationMenu()"
            />
            <mi-menu #addConversationMenu [items]="addConversationMenuItems"></mi-menu>
          </ng-container>
          <ng-container left>
            @if (conversationListService.loggedInUserId) {
              <app-conversation-list
                id="sidebar"
                [aiMode]="aiMode"
                (askAi)="openAiMode()"
                (newAiChat)="newAiChat()"
              ></app-conversation-list>
            }
            @if (!conversationListService.loggedInUserId) {
              <div class="offline-list">
                <input pInputText [(ngModel)]="offlineConversationId" />
                <button (click)="loadOfflineConversation()">Load conversation</button>
              </div>
            }
          </ng-container>
          <ng-container right>
            @if (aiConfigIncomplete) {
              <p-message severity="warn" [closable]="false" styleClass="ai-config-warning">
                MAIS options are not fully set. Set an Auth Token and Workspace Slug on the
                <a routerLink="/options">Options</a> page to use AI mode.
              </p-message>
            }
            <mi-chat
              #michat
              [theme]="themeService.theme()"
              [locale]="localeService.locale()"
              [conversationId]="conversationId"
              [reloadUser]="false"
              [hostOffline]="devToolsService.hostOffline()"
              [config]="config"
              [previewMode]="devToolsService.previewMode()"
              [aiMode]="aiMode"
              [aiConfig]="aiConfig"
              (onAiThreadReady)="onAiThreadReady($event)"
              (onAiSourcesReceived)="onAiSourcesReceived($event)"
              (onAiStreamError)="onAiStreamError($event)"
              (onAiHandoffRequested)="onAiHandoffRequested($event)"
              id="conversationComponent"
              (onHeaderButtonClick)="headerButtonClick($event)"
              (onUploadStart)="uploadStart($event)"
              (onUploadEnd)="uploadEnd($event)"
              (onActionCardOpenLink)="onActionCardOpenLink($event)"
              (onConversationLoadStart)="conversationLoadStart($event)"
              (onConversationLoadEnd)="conversationLoadEnd($event)"
              [sendOverride]="sendOverride"
              (onNameClick)="nameClicked($event)"
              (onMentionClick)="mentionClicked($event)"
              (onShareLocation)="shareLocation($event)"
              (onActionCardEvent)="onActionCardEvent($event)"
              (onAnalyticEvent)="analyticEvent($event)"
              (onInfoLog)="onChatLog($event)"
              (onErrorLog)="onChatLog($event)"
              (onSelectMessageMode)="onSelectMessageMode($event)"
              (onIgniteHotkeyPressed)="onIgniteHotkeyPressed($event)"
            ></mi-chat>
            @if (!aiMode) {
              <div class="chat-info" [ngClass]="{ 'open': showingInfo, 'chat-info-mobile': isMobile }">
                <mi-chat-info
                  #miChatInfo
                  [title]="'Information'"
                  [config]="chatInfoConfig"
                  [about]="infoAbout"
                  [aboutButtons]="infoAboutButtons"
                  [buttons]="infoButtons"
                  [actions]="infoActions"
                  [conversationId]="conversationId"
                  [getParticipantsFromChatComponent]="true"
                  [notificationSettings]="notificationSettings"
                  (onClose)="toggleInfo()"
                  (onAction)="onChatInfoAction($event)"
                  (onInfoAboutButtonClick)="onInfoAboutButtonClick($event)"
                  (onParticipantClick)="participantClicked($event)"
                  (onCallClick)="callClicked($event)"
                  (onEmailClick)="emailClicked($event)"
                  (onPreferencesClick)="preferencesClicked()"
                  (optInOrOutClick)="optInOrOutClick()"
                  (unmuteDMClick)="unmuteDMClick()"
                  (muteDMClick)="muteDMClick($event)"
                  (reloadSettingsClick)="reloadSettingsClick()"
                  (onEditStream)="editStream($event)"
                  (onAnalyticEvent)="analyticEvent($event)"
                  (onInfoLog)="onChatLog($event)"
                  (onErrorLog)="onChatLog($event)"
                  (onGoToAttachmentMessage)="goToAttachmentMessage($event)"
                  (onFullScreenPreview)="fullScreenPreview($event)"
                  (onIgniteHotkeyPressed)="onIgniteHotkeyPressed($event)"
                >
                  <info-test-page chat-info-generic-1 [test]="conversationId"> </info-test-page>
                  <info-test-page-two chat-info-generic-2> </info-test-page-two>
                </mi-chat-info>
              </div>
              <div class="chat-suggestions" [ngClass]="{ open: devToolsService.showingSuggestions() }">
                <chat-suggestion
                  #chatSuggestion
                  [parentConversationId]="conversationId"
                  [useStubData]="useStubSuggestions"
                >
                </chat-suggestion>
              </div>
            }
          </ng-container>
        </mi-two-pane-layout>
      </div>
    }
  }
</div>
